//   
// AGNES - Technical Support Web
//   
// UserProfileController.js
//   
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//   
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//   
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//   
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

angular.module("Agnes")
    .controller("RepairerProfileController", [
        "$scope", "$sessionStorage", "$activity", "$http", "$state", "$oidc",
        function ($scope, $sessionStorage, $activity, $http, $state, oidc) {
            $scope.repairer = $sessionStorage.repairer;


            $scope.apply = function () {
                $activity.start();


                $http
                    .post("/api/repairer/update", $scope.repairer, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.repairer = response.data;
                        $scope.$close();

                    }, function (response, status) {
                        $notification.addError(status.text);
                    }).then(function () {
                        $activity.finish();
                    });

            };

        }
    ]);